/**
 * The completion base status as a chain of switches, one per candidate status in lifecycle
 * order: a switch is on when its status is the stored one or an earlier one.
 */

/** Whether the switch at `index` is on for the stored `baseStatus`. */
export function isBaseStatusSwitchOn<TStatus extends string>(
  statuses: readonly TStatus[],
  baseStatus: TStatus,
  index: number
): boolean {
  return index <= statuses.indexOf(baseStatus);
}

/**
 * The base status after the switch at `index` flips: turning it on implies every earlier one,
 * turning it off drops every later one. The first status is the minimum and never goes off.
 */
export function baseStatusAfterSwitch<TStatus extends string>(
  statuses: readonly TStatus[],
  index: number,
  isOn: boolean
): TStatus {
  const lastOn = isOn ? index : index - 1;
  return statuses[Math.min(Math.max(lastOn, 0), statuses.length - 1)];
}
